import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Pagination,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from "react-redux";
import ConfirmDelete from "../ConfirmDelete";
import { createAxios } from "../../createAxios";
import {
  useDeleteSliderMutation,
  useSlidersByCollectionQuery,
} from "../../queries/useToeicQueries";

function Sliders() {
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const currentUser = useSelector((state) => state.user.signin.currentUser);
  const accessToken = currentUser?.metadata.tokens.accessToken;
  const axiosJWT = createAxios(currentUser);
  const { collection } = useParams();
  const { data: content = [] } = useSlidersByCollectionQuery(collection);
  const deleteSliderMutation = useDeleteSliderMutation();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleDelete = async (id) => {
    await deleteSliderMutation.mutateAsync({ accessToken, id, axiosJWT });
  };

  return (
    <Box
      sx={{
        width: "100%",
        mt: 4,
        mb: 6,
      }}
    >
      <Box component="header" sx={{ maxWidth: 820 }}>
        <Typography
          component="h1"
          sx={{
            color: "var(--toeic-ink-deep)",
            fontSize: { xs: 32, md: 44 },
            fontWeight: 800,
            letterSpacing: 0,
            lineHeight: 1.05,
          }}
        >
          Collection{" "}
          <Box
            component="span"
            sx={{
              color: "var(--toeic-sky-deep)",
              background: "linear-gradient(180deg, transparent 58%, rgba(70,168,232,.2) 0)",
            }}
          >
            Sliders
          </Box>
          .
        </Typography>
        <Typography sx={{ mt: 1, color: "var(--toeic-ink-soft)", fontWeight: 700, lineHeight: 1.7 }}>
          Editing collection {collection}.
        </Typography>
      </Box>

      <Box sx={{ mt: 4, borderTop: "1.5px dotted var(--toeic-line)" }} />
      <TableContainer
        component={Paper}
        sx={{
          mt: 4,
          width: "100%",
          borderRadius: "14px",
          border: 0,
          boxShadow: "var(--toeic-shadow-card)",
          overflow: "hidden",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "var(--toeic-sky)" }}>
              <TableCell sx={{ fontWeight: "bold", color: "#ffffff" }}>
                ID
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#ffffff" }}>
                Content
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#ffffff" }}>
                Link
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#ffffff" }}>
                Image
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "#ffffff" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {content
              ?.slice((page - 1) * itemsPerPage, page * itemsPerPage)
              .map((row, index) => (
                <TableRow
                  key={row._id}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#f3f6f9" : "#ffffff",
                    "&:hover": {
                      backgroundColor: "#e8f6ff",
                    },
                  }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.slider_content}</TableCell>
                  <TableCell>
                    <Link
                      style={{ color: "#2196f3" }}
                      to={collection.slider_link}
                    >
                      {row.slider_link}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <img
                      src={row.slider_image}
                      alt={row.slider_name}
                      style={{
                        width: "100px",
                        height: "auto",
                        padding: "5px",
                        border: "1px solid #ddd",
                        borderRadius: "10px",
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      component={Link}
                      to={`/update/slider/${row._id}`}
                      color="primary"
                      sx={{ mr: 1 }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton>
                      <ConfirmDelete
                        onDelete={() => handleDelete(row._id)}
                        color="#F44336"
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        count={Math.ceil(content?.length / itemsPerPage)}
        page={page}
        onChange={handleChangePage}
        sx={{ mt: 3, display: "flex", justifyContent: "center" }}
      />
    </Box>
  );
}

export default Sliders;

